export default "__VITE_ASSET__CwjuN9p5__"